import { dataSearch, isMounted } from '../../helpers/getter-commons';

// Config
const getConfigBase = (state) => dataSearch(state.config.data);
export const getConfig = getConfigBase;
export const isConfigFetching = (state) => state.config.isFetching;
export const isConfigMounted = (state) => isMounted(state.config.data);
export const configError = (state) => state.config.errorMessage;

export const getBrokers = (state) =>
  getConfigBase(state).brokers ? getConfigBase(state).brokers : [];

export const getLiveFeedPools = (state) =>
  getConfigBase(state).liveFeedPools ? getConfigBase(state).liveFeedPools : {};

export const getLiveFeedPoolsConfig = (state) =>
  getConfigBase(state).poolsConfig ? getConfigBase(state).poolsConfig : [];

export const getLiveFeedPoolsConfigYaml = (state) =>
  getConfigBase(state).poolsConfigYaml
    ? getConfigBase(state).poolsConfigYaml
    : '';

export const getReferralTypes = (state) =>
  getConfigBase(state).referralTypes ? getConfigBase(state).referralTypes : [];

export const getPoolsConfigNote = (state) =>
  getConfigBase(state).poolsConfigNote
    ? getConfigBase(state).poolsConfigNote
    : '';
